import { render } from "./gcp.vue?vue&type=template&id=159a724f"
import script from "./gcp.vue?vue&type=script&lang=js"
export * from "./gcp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__